module.exports = __webpack_public_path__ + "img/edit-border.d939b29a.svg";